<form [formGroup]="form">
  <div class="title">
    <img src="../../../assets/icons/fogo-e-peixe.png" class="logo" width="150" />
    <h2>Cadastrar nova senha</h2>
  </div>

  <input autocomplete="username" value="teste.com" hidden />
  <mat-form-field appearance="outline">
    <mat-label>Nova senha</mat-label>
    <input matInput autocomplete="new-password" type="password" formControlName="password" />
    <mat-error *ngIf="form.controls.password.hasError('required')"> Senha obrigatorio! </mat-error>
    <mat-error *ngIf="form.controls.password.hasError('minlength')"> Senha muito pequena! </mat-error>
    <mat-error *ngIf="form.controls.password.hasError('maxlength')"> Senha muito grande! </mat-error>
  </mat-form-field>
  <br />
  <br />

  <mat-form-field appearance="outline">
    <mat-label>Repita a nova senha </mat-label>
    <input matInput type="password" autocomplete="new-password" formControlName="new-password" />
  </mat-form-field>

  <br />
  <button class="btn-primary" mat-raised-button (click)="resetPassword()" [disabled]="!form.valid">Salvar</button>
</form>
